// Icons
import HomeIcon from "@material-ui/icons/Home";
import AssignmentIcon from "@material-ui/icons/Assignment";

// Pages
import {
  Report,
  ReportViewer,
} from "./pages";

export default {
  items: [
    {
      path: "/report",
      name: "報告",
      key: "report",
      type: "link",
      icon: AssignmentIcon,
      component: Report,
      sideBar: true,
    },
    {
      path: "/report-viewer/:pid",
      name: "報告ビューワー",
      key: "view",
      type: "link",
      icon: HomeIcon,
      component: ReportViewer,
      sideBar: false,
    },
  ],
};
